<template>
  <div>
    <div
      v-if="searchTerm && !isFetching"
      class="mb-3 text-uppercase"
    >
      {{ `Search results for"${searchTerm}" (${finalImages.length})` }}
    </div>
    <div
      :class="[
        isPdp ? 'w-100' : ''
      ]"
    >
      <div
        class="no-results justify-content-center"
        v-if="!isFetching && finalImages.length === 0"
      >
        <Icon
          class="w-100"
          icon="fluent:search-info-24-regular"
          color="#959595"
          width="30px"
        />
        <p class="no-results-header text-center">
          {{ $resourceString["inspiration.images.gallery.no.images.header"] }}
        </p>
        <p class="no-results-subheader text-center">
          {{
            $resourceString["inspiration.images.gallery.no.images.subheader"]
          }}
        </p>
        <div class="no-results-box">
          <div class="button-label">
            {{
              $resourceString[
                "inspiration.images.gallery.no.images.need.assistance"
              ]
            }}
          </div>
          <a href="/Contact-Us" class="btn btn-primary text-uppercase">
            {{
              $resourceString["inspiration.images.gallery.no.images.contact.us"]
            }}
          </a>
        </div>
      </div>

      <div v-if="finalImages.length > 0 && !isWidget">
        <h4 class="primary-heading text-lowercase font-weight-bold mb-3 patcraft-text-underline" :data-text="productInstallLabel ? (productInstallLabel.slice(0, 3)) : ''" v-if="isPdp">
          {{ productInstallLabel }}
        </h4>
        <h4 class="secondary-heading" v-else>
          {{ productInstallLabel }}
        </h4>
      </div>
      <div class="gallery-block-mobile" />
      <div class="wf-inspiration-items-desktop d-flex flex-wrap">
        <div
          v-if="numberOfImages && numberOfImages > 0"
          v-for="index in numberOfImages"
          :key="index"
          class="wf-inspiration-item inspiration-page-gallery-item"
        >
          <div
            v-if="finalImages[index - 1]"
            class="
          wf-inspiration-overlay-button-open
          inspiration-page-gallery-item-button
          position-relative
        "
          >
            <span
              class="png-icon png-icon-icons-glyph--ko-heart cursor-pointer position-absolute mt-3 insp-gallery-heart"
              @click="showContentWizard(finalImages[index - 1])"
            ></span>
            <div class="w-100 h-100 bg-light">
              <img
                :wrapper-class="'w-100 h-100 bg-light'"
                :class="'image wf-inspiration-grid-image'"
                :src="$helpers.getWidenImgURL(finalImages[index - 1].embedId, 1000)"
                :alt="(finalImages[index - 1].imageAltText || '')"
              />
            </div>
            <div
              class="
            wf-inspiration-overlay-button-open-text
            secondary-heading cursor-pointer
            info-secondary-heading
            inspiration-page-gallery-item-name
          "
              @click.prevent.stop="onImgClick(finalImages[index - 1])"
            >
              {{ finalImages[index - 1].displayCollectionName }}
            </div>
          </div>
        </div>

        <div
          v-if="!numberOfImages && numberOfImages != 0"
          class="wf-inspiration-item inspiration-page-gallery-item"
          v-for="image in finalImages"
          :key="image.embedId"
        >
          <div
            class="
              wf-inspiration-overlay-button-open
              inspiration-page-gallery-item-button
              position-relative
            "
          >
            <span
              class="png-icon png-icon-icons-glyph--ko-heart cursor-pointer position-absolute mt-3 insp-gallery-heart"
              @click="showContentWizard(image)"
            ></span>
            <div class="w-100 h-100 bg-light">
              <img
                :wrapper-class="'w-100 h-100 bg-light'"
                :class="'image wf-inspiration-grid-image'"
                :src="$helpers.getWidenImgURL(image.embedId, 1000)"
                :alt="(image.imageAltText || '')"
              />
            </div>
            <div
              class="
                wf-inspiration-overlay-button-open-text
                secondary-heading cursor-pointer
                info-secondary-heading
                inspiration-page-gallery-item-name
              "
              @click.prevent.stop="onImgClick(image)"
            >
              {{ image.displayCollectionName }}
            </div>
          </div>
        </div>

        <pc-load-more v-if="showLoadMore && !isPdp" :load-more="onLoadMore" />
      </div>
      <div
        v-if="isPdp"
        class=" inspiration-btn wf-cta-block-call-to-action-buttons text-center"
      >
        <a
          class="call-to-action-button btn btn-white border-accent-gray-alt bg-transparent"
          @click="inspirationRedirect()"
          target="_self"
        >
          {{ $resourceString["product.details.side.inspiration.label"] }}
          <span class="png-icon png-icon-icons-glyph--k-arrow-next"> </span>
        </a>
      </div>
      <pc-inspiration-images-gallery v-if="imgPreviewOpened" />
    </div>
    <modal
      height="650"
      name="project-wizard-image-content-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      class="my-project-modal"
      :scrollable="true"
    >
      <pc-project-wizard-content-modal
        @closeModal="closeModal($event)"
      ></pc-project-wizard-content-modal>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PcInspirationImagesGallery from "./pc-inspiration-images-gallery.vue";
import WFLoadImage from "../wf-load-image.vue";
import { Icon } from "@iconify/vue2";
import PcLoadMore from "../common/pc-loading-more.vue";
import { ContentItemTypes, step1Data } from "../../../stepTree";
import PcProjectWizardContentModal from "../content-wizard-modal/pc-project-wizard-content-modal.vue";
import commonMethods from "../../../scripts/common-methods";
export default {
  props: ["isWidget", "widgetData", "numberOfImages", "uniqueKey"],
  components: {
    "wf-load-image": WFLoadImage,
    PcInspirationImagesGallery,
    PcProjectWizardContentModal,
    PcLoadMore,
    Icon
  },
  data() {
    return {
      productInstallLabel: this.$resourceString["inspiration.Images.Gallery.ProductInstall.Label"],
      finalImages: []
    };
  },
  computed: {
    ...mapGetters({
      imgPreviewOpened: "inspirationPage/imgPreviewOpened",
      images: "inspirationPage/images",
      showLoadMore: "inspirationPage/showLoadMore",
      isFetching: "inspirationPage/isFetching",
      pageNumber: "inspirationPage/pageNumber",
      isFilterOptionsOpened: "inspirationPage/isFilterOptionsOpened",
      searchTerm: "filters/searchTerm",
      totalCount: "inspirationPage/totalCount",
      isPdp: "inspirationPage/isPdp",
      productData: "productDetail/productData",
      selectedProduct: "productDetail/selectedProduct",
      filters: "filters/filters",
      userIsAuthenticated: "contentWizard/getuserIsAuthenticated"
    }),

    processedTitle() {
      return commonMethods.processHeading(this.productInstallLabel);
    }
  },

  mounted() {
    if (this.isWidget) {
      this.setImageData(this.widgetData.map(obj => this.convertKeysToLowerCase(obj)));
      this.finalImages = this.widgetData.map(obj => this.convertKeysToLowerCase(obj));
    }
    this.openModalIfLoggedIn();
  },
  watch: {
    images: {
      handler: function(newValue, oldValue) {
        if(!this.isWidget) this.finalImages = newValue
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      setImgPreviewOpened: "inspirationPage/setImgPreviewOpened",
      setOpenedImage: "inspirationPage/setOpenedImage",
      setPageNumber: "inspirationPage/setPageNumber",
      updateTranding: "inspirationPage/updateTranding",
      setIsFilterOptionsOpened: "inspirationPage/setIsFilterOptionsOpened",
      setStep1: "contentWizard/setStep1",
      setStep: "contentWizard/setStep",
      setContentType: "contentWizard/setContentType",
      setContentItem: "contentWizard/setContentItem",
      updatId: "contentWizard/updateselectedTrayId",
      setIsOutOfProject: "contentWizard/setIsOutOfProject",
      resetContent: "contentWizard/resetContent",
      resetContentType: "contentWizard/resetContentType",
      setImageData: "inspirationPage/setResults",
      reSetSelectedFilter:  "filters/reSetSelectedFilter",
    }),

    convertKeysToLowerCase(obj) {
      const newObj = {};
      for (const key in obj) {
        const lowerCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
        if (
          typeof obj[key] === "object" &&
          obj[key] !== null &&
          !Array.isArray(obj[key])
        ) {
          newObj[lowerCaseKey] = this.convertKeysToLowerCase(obj[key]);
        } else if (Array.isArray(obj[key])) {
          newObj[lowerCaseKey] = obj[key].map(item =>
            this.convertKeysToLowerCase(item)
          );
        } else {
          newObj[lowerCaseKey] = obj[key];
        }
      }
      return newObj;
    },

    closeModal() {
      this.$modal.hide("project-wizard-image-content-modal");
    },

    openModalIfLoggedIn() {
      const urlParams = new URLSearchParams(window.location.search);
      const hash = window.location.hash;
      // Check if openModal parameter exists in query string
      if (
        urlParams.has("openModal") &&
        urlParams.get("openModal") === "gallery"
      ) {
        this.showContentWizard();
        setTimeout(() => {
          commonMethods.removeQueryParam();
          this.reSetSelectedFilter();
        },5000)
        return;
      }
      // Check if openModal parameter exists in fragment identifier
      const hashParams = new URLSearchParams(hash.substring(1));
      if (
        hashParams.has("openModal") &&
        hashParams.get("openModal") === "gallery"
      ) {
        this.showContentWizard();
      }

      //gallery-pdp
      if (
        urlParams.has("openModal") &&
        urlParams.get("openModal") === "gallery-pdp"
      ) {
        this.setImgPreviewOpened(true);
        setTimeout(() => {
          commonMethods.removeQueryParam();
        }, 5000);
        return;
      }
      if (
        hashParams.has("openModal") &&
        hashParams.get("openModal") === "gallery-pdp"
      ) {
        this.setImgPreviewOpened(true);
      }
    },

    async showContentWizard(value) {
      if (userIsAuthenticated === "true" || userIsAuthenticated === true) {
        this.$modal.show("project-wizard-image-content-modal");
        // Reset Content Wizard State
        this.resetContentType();
        this.resetContent();

        let data = value
          ? value
          : JSON.parse(localStorage.getItem("galleryData"));
        localStorage.removeItem("galleryData");

        // Set content wizard type
        this.setIsOutOfProject(true);

        // Set step data
        this.setStep(3);
        this.setContentType(step1Data.galleryImages.defaultType);
        this.setStep1({ selectedType: "galleryimages" });
        this.updatId(data.id);
        // Set Content Wizard New Data
        this.setContentItem({
          coverPhoto: this.$helpers.getWidenImgURL(data.embedId, 1000),
          coverPhotoImageAltText: data.imageAltText || '',
          title: data.displayCollectionName,
          itemBoardId: data.id,
          type: ContentItemTypes.galleryImages
        });
      } else {
        localStorage.setItem("galleryData", JSON.stringify(value));
        commonMethods.fallBackURL("gallery");
      }
    },

    inspirationRedirect() {
      let url = new URL(window.location);
      let categoryValue = url.searchParams.get("category");
      let newUrl = "/inspiration?";
      let checkStyleNumber = this.finalImages.find(
        ({ mainProduct }) =>
          mainProduct.sellingStyleNumber ===
          this.selectedProduct.sellingStyleNumber
      );
      if (checkStyleNumber) {
        newUrl += "searchTerm=" + this.productData.sellingStyleNumber + "&";
        newUrl +=
          "Collection=" + encodeURIComponent(this.productData.collection);
      } else {
        newUrl +=
          "Collection=" + encodeURIComponent(this.productData.collection);
      }
      const result = this.filters.find(
        ({ name }) => name === "Market segments"
      );
      let category = "";
      if (result && result["options"].length > 0) {
        let isCategoryAvailable = result["options"].find(
          element => element == categoryValue
        );
        if (isCategoryAvailable) {
          category = isCategoryAvailable;
          newUrl += "&SegmentType=" + encodeURIComponent(category);
        }
      }
      window.location.href = newUrl;
    },
    onImgClick(image) {
      localStorage.setItem("imageData", JSON.stringify(image));
      if (this.isFilterOptionsOpened) {
        this.setIsFilterOptionsOpened(false);
      }
      this.setOpenedImage(image);
      this.setImgPreviewOpened(true);
      this.$helpers.disableScrolling();
      this.updateTranding({ widenAssetId: image.id });
    },
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.setPageNumber(this.pageNumber + 1);
    }
  }
};
</script>

<style></style>
